import Logo from '../Images/logo.png'

export default function HeaderPruebas() {
    return(
        <div className="header_prueba">
            <img alt="header_prueba" src={Logo}/>
        </div>
    )
}
